import * as React from "react";
import "./styles.scss";
import {COLOR} from "utils/variables";

interface IProps {
    size?: string;
    buttonText: string;
    isDisabled?: boolean;
    onClick?: () => void;
    rounded?: boolean;
    bgColor?: string;
    width?: string;
    maxWidth?: number;
    fontWeight?: number;
    height?: number;
    iconUrl?: string;
    textColor?: string;
}

export enum SIZE {
    LARGE = "large",
}

export const Button = (props: IProps) => {
    const buttonStyle = {
        display: "flex",
        justifyContent: "center",
        fontSize: 14,
        backgroundColor: !props.isDisabled ? props.bgColor ? props.bgColor : COLOR.BUTTON_PRIMARY : COLOR.BUTTON_DISABLED,
        boxShadow: `0px 3px 6px ${COLOR.SHADOW}`,
        borderRadius: props.rounded ? 22 : 6,
        color: !props.isDisabled ? props.textColor ? props.textColor : COLOR.WHITE : COLOR.DARK_GRAY,
        width: !props.width ?  props.size === SIZE.LARGE ? "calc(100vw - 30%)" : "calc(100vw - 60%)" : props.width,
        padding: "9px 0",
        maxWidth: props.maxWidth ? props.maxWidth : 300,
        margin: "auto",
        height: props.height ? props.height : 47,
        fontWeight: props.fontWeight ? props.fontWeight : 600,
        alignItems: "center",
    };
    return (
        <div className={`button ${props.isDisabled ? " disabled" : ""}`} style={buttonStyle}
             onClick={() => props.onClick ? props.onClick() : undefined}>
            <div className={"button-text"}>
                {props.buttonText}
            </div>
            {props.iconUrl &&
                <div className="icon">
                    <img src={props.iconUrl} alt="icon"/>
                </div>}
        </div>
    );
};

export default Button;
